import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import {
  Account, useAppDispatch, EntryItemBase, CollectionEntity, useWatchNode, DriveEntryType, DriveUIActionTypes, DriveWatchedMessages, Message, MessageAnchors,
  COLLECTION_PROTOCOL_VERSIONS
} from "src/common";
import { Icon } from "src/components";
import { uiActions, driveActions } from "src/store";

type AllProps = {
    current_account: Account;
    entry: EntryItemBase;
    collection_info: CollectionEntity;
    hidden?: boolean;
    className?: string;
    current_details?: boolean;
    handleAction: ActionHandlerFunction;
}

function WatchedSwitchItemComponent(props: AllProps) {
    const { current_account, entry, collection_info, hidden, className, current_details, handleAction } = props;
    const dispatch = useAppDispatch();
    const [watched, setWatched] = useState<boolean>(collection_info.permissions.is_watched);
    const { setNodeWatchState, reset, success, error } = useWatchNode(current_account);

    useEffect(() => {
        // NOTE: reconcile state when it is different from saved (from other dropdowns)
        collection_info.permissions.is_watched !== watched &&
            setWatched(collection_info.permissions.is_watched);
    }, [collection_info]);

    useEffect(() => {
        (!!error || !!success) && dispatch(driveActions.setLoading(false));
        !!error && handleError();
        !!success && handleSuccess();
    }, [success, error]);

    // Description: Handle Toggle of Watched
    function handleChange() {
        const new_watch = !watched;
        setWatched(new_watch);
        const id = entry.type !== DriveEntryType.LINK ? entry.id :
            (collection_info.collection_protocol_version === COLLECTION_PROTOCOL_VERSIONS.V2 && !!collection_info.maintainer_id) ? collection_info.maintainer_id :
                (collection_info.collection_protocol_version === COLLECTION_PROTOCOL_VERSIONS.V1 && collection_info.is_root && !!collection_info.root_id) ? collection_info.root_id :
                    collection_info.id;
        const entry_base = {
            id,
            maintainer_id: collection_info.maintainer_id,
            collection_id: collection_info.collection_id,
            linked_collection_id: entry.linked_collection_id,
            type: entry.type
        };
        setNodeWatchState(entry_base, new_watch, collection_info.collection_protocol_version);
    }

    // Description: Handle Success after toggle
    function handleSuccess() {

        const msg = DriveWatchedMessages.success_setting_watch.replace(MessageAnchors.actionType,
            collection_info.permissions.is_watched ? "removed from" : "added to");
        dispatch(uiActions.handleSetMessage(new Message(msg)));
        !!current_details ? handleAction({ actionType: DriveUIActionTypes.Refresh }) :
            handleAction({ actionType: DriveUIActionTypes.GetCollectionInfo });
        reset();
    }

    // Description: Handle Success after toggle
    function handleError() {
        setWatched(collection_info.permissions.is_watched);
        reset();
    }

    return <Dropdown.Item className={!!className ? className : ""}
        hidden={!!hidden}
        data-tooltip-id="dd-tooltip"
        data-tooltip-content={watched ? "Unwatch this item" : "Watch this item"}
        data-tooltip-place="right"
        onClick={handleChange} >
        <span>
            <Icon className={watched ? "ficon-eye-off" : "ficon-eye"} />{watched ? "Unwatch" : "Watch"}
        </span>
    </Dropdown.Item>;
}

export default React.memo(WatchedSwitchItemComponent);